import { render, staticRenderFns } from "./RbxConfirmDialog.vue?vue&type=template&id=b514635e&"
import script from "./RbxConfirmDialog.vue?vue&type=script&lang=js&"
export * from "./RbxConfirmDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RbxConfirmDialog.vue"
export default component.exports